import { Route, Routes } from "react-router-dom";
import { BidPackagesPage } from "src/routes/bids/BidPackagesPage";
import { PurchaseOrdersPage } from "src/routes/developments/purchase-orders/PurchaseOrdersPage";
import {
  bidPackagePath,
  relativeTradesPath,
  tradesBidContractsPath,
  tradesPurchaseOrdersPath,
  tradesTradePartnersPath,
} from "src/routes/routesDef";
import { TradePartnersPage } from "src/routes/trade-partners/TradePartnersPage";
import { GlobalBidContractsPage } from "src/routes/trades/bid-contracts/GlobalBidContractsPage";

export function TradesLayout() {
  const rt = relativeTradesPath;

  return (
    <Routes>
      <Route path={rt(tradesTradePartnersPath)} element={<TradePartnersPage />} />
      <Route path={rt(tradesPurchaseOrdersPath)} element={<PurchaseOrdersPage isGlobal={true} isTrades={true} />} />
      <Route path={rt(tradesBidContractsPath)} element={<GlobalBidContractsPage />} />
      <Route path={rt(bidPackagePath)} element={<BidPackagesPage />} />
    </Routes>
  );
}
